// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3zI9J","col":"styles_col__31Bgu"};